<template>
  <component :is="baseComponent"
             :to="link.path ? link.path : '/'"
             :class="{active: isActive}"
             tag="li"
             v-if="hasAccess">
    <a v-if="isMenu && !isLink"
       data-toggle="collapse"
       href="javascript:void(0)"
       @click="collapseMenu">
       <div class="nav-icon">
         <img :src="link.icon" alt="Icon">
       </div>
      <p>
        {{link.name}}
        <component v-if="link.nameAfter" :is="link.nameAfter"></component>
        <b
          class="caret"
          :class="{'caret--opened': !collapsed}"
        />
      </p>
    </a>
    <router-link v-if="isLink"
       data-toggle="collapse"
       :to="link.path"
       :href="'/#' + link.path"
       @click.native="closeSidebar($event)"
       @click="collapseMenu">
       <div class="nav-icon">
         <img :src="link.icon" alt="Icon">
       </div>
      <p>
        {{link.name}}
        <component v-if="link.nameAfter" :is="link.nameAfter"></component>
      </p>
    </router-link>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition>
        <ul class="nav" v-show="!collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>
    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path">
      <router-link
        v-if="!isLink"
        :to="link.path"
        :class="{active: link.active}"
        :target="link.target"
        @click.native="closeSidebar($event)"
        >
        <template v-if="addLink">
          <span class="sidebar-mini">{{link.name.substring(0, 1)}}</span>
          <span class="sidebar-normal">
            {{link.name}}
            <component v-if="link.nameAfter" :is="link.nameAfter"></component>
          </span>
        </template>
      </router-link>
    </slot>
  </component>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    props: {
      isLink: {
        type: Boolean,
        default: false
      },
      menu: {
        type: Boolean,
        default: false
      },
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
            children: []
          }
        }
      },
      linkAccess: {
        type: String,
        default: ''
      }
    },
    provide () {
      return {
        addLink: this.addChild,
        removeLink: this.removeChild
      }
    },
    inject: {
      addLink: {default: null},
      removeLink: {default: null}
    },
    data () {
      return {
        children: [],
        collapsed: true
      }
    },
    computed: {
      baseComponent () {
        return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
      },
      isMenu () {
        return this.children.length > 0 || this.menu === true
      },
      isActive () {
        if (this.$route) {
          let matchingRoute = this.children
            .find((c) => this.$route.path.startsWith(c.link.path))
          if (matchingRoute !== undefined) {
            return true
          }
        }
        return false
      },
      user () {
        return this.$store.state.user.user
      },
      hasAccess: self => {
        if (self.user) {
          if (!self.linkAccess) {
            return true;
          } else {
            return self.$store.state.user.user.checkRole(self.linkAccess)
          }
        }
      }
    },
    methods: {
      closeSidebar (event) {
        this.$store.commit('sidebarOpened', false)
        this.$nextTick(() => {
          var evt = document.createEvent('MouseEvents');
          evt.initMouseEvent('mouseout', true, true, window,
                             0, 0, 0, 0, 0, false, false, false, false, 0, null);
          this.$root.$el.dispatchEvent(evt)
          event.target.dispatchEvent(evt);
        })
      },
      addChild (item) {
        const index = this.$slots.default.indexOf(item.$vnode)
        this.children.splice(index, 0, item)
      },
      removeChild (item) {
        const tabs = this.children
        const index = tabs.indexOf(item)
        tabs.splice(index, 1)
      },
      elementType (link, isParent = true) {
        if (link.isRoute === false) {
          return isParent ? 'li' : 'a'
        } else {
          return 'router-link'
        }
      },
      linkAbbreviation (name) {
        const matches = name.match(/\b(\w)/g)
        return matches.join('')
      },
      collapseMenu () {
        this.collapsed = !this.collapsed
      },
      collapseSubMenu (link) {
        link.collapsed = !link.collapsed
      }
    },
    mounted () {
      if (this.addLink) {
        this.addLink(this)
      }
      if (this.link.collapsed !== undefined) {
        this.collapsed = this.link.collapsed
      }
      if (this.isActive && this.isMenu) {
        this.collapsed = false
      }
    },
    destroyed () {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
      if (this.removeLink) {
        this.removeLink(this)
      }
    }
  }
</script>
<style>
</style>